import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Loader } from '@els/els-react--loader';
import Button from '@Components/Button';
import QuickResultPredictButton from '@Pages/QuickSearch/Components/QuickResults/QuickResultPredictButton';
// eslint-disable-next-line import/no-named-as-default
import PreviewResultsHeatmapButtonContainer from '@Containers/PreviewResultsHeatmapButton/PreviewResultsHeatmapButtonContainer';

function BlockActionButtons({
  previewItem,
  showProgressLoader,
  onCancelClick,
  showQueryCancelled,
  showExpandButton,
  expandButtonConfig,
  expandButtonAttrs,
  expanded,
  toggleExpanded,
  showViewResultsButton,
  onViewResultsButtonClick,
  showPredictionButton,
  showBioactivityVisualizationButton,
}) {
  return (
    <div className="results-preview__block results-preview__block--action-buttons">
      {showProgressLoader && (
        <div className="results-preview__action-buttons-row">
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              className: 'blue-compact',
              label: 'cancel progress',
              e2eName: 'cancel',
            }}
            onClick={onCancelClick}
          />
          <Loader isSmall isBlocking={false} isVisible className="results-preview__progress-loader e2e-progress-loader" />
        </div>
      )}

      {showQueryCancelled && (
        <div className="results-preview__action-buttons-row">
          <div className="showMore__cancelInfo">{`Search cancelled${get(previewItem, 'query.error') ? ' due to an error' : ''}`}</div>
        </div>
      )}

      <div className="results-preview__action-buttons-row">
        {showExpandButton && (
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              className: 'blue-compact',
              ...expandButtonConfig,
            }}
            onClick={toggleExpanded}
            iconConfig={{
              name: expanded ? 'chevron-up' : 'chevron-down',
              size: 'sm',
            }}
            aria-expanded={expanded}
            {...expandButtonAttrs}
          />
        )}
        {showViewResultsButton && (
          <Button
            buttonConfig={{
              type: 'tertiary',
              size: 'md',
              label: 'View Results',
              e2eName: 'view-results',
            }}
            onClick={onViewResultsButtonClick}
            iconConfig={{
              name: 'chevron-right',
              size: 'md',
            }}
            aria-label={`View results from ${previewItem.databaseLabel}`}
            aria-describedby={previewItem.queryId}
          />
        )}
      </div>
      {showPredictionButton && <QuickResultPredictButton {...previewItem} />}
      {showBioactivityVisualizationButton && <PreviewResultsHeatmapButtonContainer {...previewItem} />}
    </div>
  );
}

BlockActionButtons.defaultProps = {
  onCancelClick: () => {},
  toggleExpanded: () => {},
  onViewResultsButtonClick: () => {},
};

BlockActionButtons.propTypes = {
  previewItem: PropTypes.object.isRequired,
  showProgressLoader: PropTypes.bool,
  onCancelClick: PropTypes.func,
  showQueryCancelled: PropTypes.bool,
  showExpandButton: PropTypes.bool,
  expandButtonConfig: PropTypes.object,
  expandButtonAttrs: PropTypes.object,
  expanded: PropTypes.bool,
  toggleExpanded: PropTypes.func,
  showViewResultsButton: PropTypes.bool,
  onViewResultsButtonClick: PropTypes.func,
  showPredictionButton: PropTypes.bool,
  showBioactivityVisualizationButton: PropTypes.bool,
};

export default BlockActionButtons;
